// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes MobileTabletBrochure_appear__2Uscd {
    from {
        opacity: 0;
        transform: translateY(100%);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes MobileTabletBrochure_appearTablet__t4ogJ {
    from {
        opacity: 0;
        transform: translateY(20px) translateX(-50%);
    }
    to {
        opacity: 1;
        transform: translateY(0) translateX(-50%);
    }
}

.MobileTabletBrochure_container__K6Mp1 {
    height: -moz-fit-content;
    height: fit-content;
    position: fixed;
    border-radius: 24px 24px 0 0;
    background-color: #111018;
    color: #fff;
    padding: 20px;
    z-index: 3000;
    animation: MobileTabletBrochure_appear__2Uscd 0.3s ease-out;
    overflow-y: auto;
}

.MobileTabletBrochure_header__9W2jR {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.MobileTabletBrochure_closeButton__vUMyk {
    border: none;
    background-color: var(--primary-light-02);
    border-radius: 50%;
    aspect-ratio: 1;
    padding: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.MobileTabletBrochure_title__M\\+It6 {
    font-size: var(--font-size-11);
    font-family: var(--font-semi-bold), sans-serif;
}

.MobileTabletBrochure_description__yVLq6 {
    font-size: var(--font-size-6);
    line-height: 24px;
    font-family: var(--font-medium), sans-serif;
    margin-bottom: 20px;
}

.MobileTabletBrochure_copyright__b7gxP {
    display: flex;
    justify-content: center;
    width: 100%;
    font-size: var(--font-size-4);
    color: var(--primary-light-05);
    text-align: center;
    margin-top: 20px;
    font-family: var(--font-light), sans-serif;
    text-decoration: none;
}

@media (max-width: 767px) {
    .MobileTabletBrochure_container__K6Mp1 {
        right: 0;
        left: 0;
        bottom: 0;
        max-width: 100%;
        padding: 16px 32px;
    }

    .MobileTabletBrochure_description__yVLq6 {
        line-height: 20px;
        margin-top: 8px;
    }
}

@media (min-width: 768px) and (max-width: 1023px) {
    .MobileTabletBrochure_container__K6Mp1 {
        bottom: 9%;
        left: 50%;
        transform: translateX(-50%);
        width: 95%;
        max-width: none;
        border-radius: 16px;
        top: unset;
        animation: MobileTabletBrochure_appearTablet__t4ogJ 0.5s ease-out;
    }
}

@media (min-width: 1024px) {
    .MobileTabletBrochure_container__K6Mp1 {
        height: -moz-fit-content;
        height: fit-content;
        bottom: 9%;
        left: 50%;
        transform: translateX(-50%);
        width: 68%;
        border-radius: 16px;
        top: unset;
        animation: MobileTabletBrochure_appearTablet__t4ogJ 0.5s ease-out;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Shared/MobileTabletBrochure/MobileTabletBrochure.module.css"],"names":[],"mappings":"AAAA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,UAAU;QACV,4CAA4C;IAChD;IACA;QACI,UAAU;QACV,yCAAyC;IAC7C;AACJ;;AAEA;IACI,wBAAmB;IAAnB,mBAAmB;IACnB,eAAe;IACf,4BAA4B;IAC5B,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,aAAa;IACb,2DAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,yCAAyC;IACzC,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;IAC9B,8CAA8C;AAClD;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,6BAA6B;IAC7B,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,0CAA0C;IAC1C,qBAAqB;AACzB;;AAEA;IACI;QACI,QAAQ;QACR,OAAO;QACP,SAAS;QACT,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,UAAU;QACV,SAAS;QACT,2BAA2B;QAC3B,UAAU;QACV,eAAe;QACf,mBAAmB;QACnB,UAAU;QACV,iEAAqC;IACzC;AACJ;;AAEA;IACI;QACI,wBAAmB;QAAnB,mBAAmB;QACnB,UAAU;QACV,SAAS;QACT,2BAA2B;QAC3B,UAAU;QACV,mBAAmB;QACnB,UAAU;QACV,iEAAqC;IACzC;AACJ","sourcesContent":["@keyframes appear {\n    from {\n        opacity: 0;\n        transform: translateY(100%);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@keyframes appearTablet {\n    from {\n        opacity: 0;\n        transform: translateY(20px) translateX(-50%);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0) translateX(-50%);\n    }\n}\n\n.container {\n    height: fit-content;\n    position: fixed;\n    border-radius: 24px 24px 0 0;\n    background-color: #111018;\n    color: #fff;\n    padding: 20px;\n    z-index: 3000;\n    animation: appear 0.3s ease-out;\n    overflow-y: auto;\n}\n\n.header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.closeButton {\n    border: none;\n    background-color: var(--primary-light-02);\n    border-radius: 50%;\n    aspect-ratio: 1;\n    padding: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.title {\n    font-size: var(--font-size-11);\n    font-family: var(--font-semi-bold), sans-serif;\n}\n\n.description {\n    font-size: var(--font-size-6);\n    line-height: 24px;\n    font-family: var(--font-medium), sans-serif;\n    margin-bottom: 20px;\n}\n\n.copyright {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    font-size: var(--font-size-4);\n    color: var(--primary-light-05);\n    text-align: center;\n    margin-top: 20px;\n    font-family: var(--font-light), sans-serif;\n    text-decoration: none;\n}\n\n@media (max-width: 767px) {\n    .container {\n        right: 0;\n        left: 0;\n        bottom: 0;\n        max-width: 100%;\n        padding: 16px 32px;\n    }\n\n    .description {\n        line-height: 20px;\n        margin-top: 8px;\n    }\n}\n\n@media (min-width: 768px) and (max-width: 1023px) {\n    .container {\n        bottom: 9%;\n        left: 50%;\n        transform: translateX(-50%);\n        width: 95%;\n        max-width: none;\n        border-radius: 16px;\n        top: unset;\n        animation: appearTablet 0.5s ease-out;\n    }\n}\n\n@media (min-width: 1024px) {\n    .container {\n        height: fit-content;\n        bottom: 9%;\n        left: 50%;\n        transform: translateX(-50%);\n        width: 68%;\n        border-radius: 16px;\n        top: unset;\n        animation: appearTablet 0.5s ease-out;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MobileTabletBrochure_container__K6Mp1`,
	"appear": `MobileTabletBrochure_appear__2Uscd`,
	"header": `MobileTabletBrochure_header__9W2jR`,
	"closeButton": `MobileTabletBrochure_closeButton__vUMyk`,
	"title": `MobileTabletBrochure_title__M+It6`,
	"description": `MobileTabletBrochure_description__yVLq6`,
	"copyright": `MobileTabletBrochure_copyright__b7gxP`,
	"appearTablet": `MobileTabletBrochure_appearTablet__t4ogJ`
};
export default ___CSS_LOADER_EXPORT___;
